import styled, { css } from 'styled-components';

import { media } from '@theme/media';

export const Container = styled.div`
  padding-top: 20px;
  margin: -34px -24px 0;
  overflow: hidden;

  ${media.tablet} {
    margin: -34px 0 0;
  }
`;
export const Content = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  scrollbar-width: none;
  margin-left: 24px;

  &::-webkit-scrollbar {
    display: none;
  }

  ${media.tablet} {
    margin-left: 0;
  }
`;

export const ArtworkContainer = styled.a`
  padding: 12px 0 0;
  margin: 0 10px;
  display: block;
  flex-direction: column;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const ImageContainer = styled.div`
  height: auto;
  width: 100%;
  margin: 0 auto;
  flex-grow: 0;
  flex-shrink: 0;
`;

export const Image = styled.img`
  object-fit: contain;
  width: 90px;
  height: 90px;
  margin: 0 auto;
  display: block;
`;

export const Caption = styled.div`
  padding-top: 7px;
  text-align: center;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.02em;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const favoriteButtonCustomStyles = css`
  margin: 0;
  padding: 0;

  svg {
    width: 8px;
  }
`;

export const Price = styled.span`
  padding: 2px 0 0 6px;
`;

export const ArrowRight = styled.span`
  padding-left: 9px;
  &:after {
    content: '\\2192';
    font-size: 0.75em;
    display: inline-block;
    transition: transform 0.2s ease-in-out;
  }
`;

export const ViewAll = styled.a`
  padding: 12px 10px 0 0;
  display: block;
  min-width: 170px;
  margin: 0;
  text-align: center;

  &:hover ${ArrowRight}:after {
    transform: translate3d(6px, 0, 0);
  }
`;

export const ViewAllCopy = styled.span`
  display: inline-block;
  margin-top: 40px;
  position: relative;
`;
